(function () {
  var root = document.querySelector('[data-pm-stride]');
  if (!root) return;

  var productHandle = root.getAttribute('data-product-handle');
  var sticky = root.querySelector('[data-stride-sticky]');
  var heroButton = root.querySelector('[data-stride-hero-button]');
  var priceNodes = root.querySelectorAll('[data-stride-price]');
  var compareNodes = root.querySelectorAll('[data-stride-compare]');
  var loadingLabel = root.getAttribute('data-loading-label') || 'Añadiendo...';
  var unavailableLabel = root.getAttribute('data-unavailable-label') || 'No disponible';
  var variantId = null;

  function money(cents, currency) {
    return new Intl.NumberFormat(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: currency || 'EUR'
    }).format(cents / 100);
  }

  fetch('/products/' + productHandle + '.js')
    .then(function (response) { return response.json(); })
    .then(function (product) {
      var variant = product.variants && product.variants[0];
      if (!variant) return;
      variantId = variant.id;
      priceNodes.forEach(function (node) { node.textContent = money(variant.price, product.currency || 'EUR'); });
      compareNodes.forEach(function (node) {
        node.textContent = money(variant.compare_at_price || variant.price, product.currency || 'EUR');
      });
    })
    .catch(function () {});

  function drawerSections(drawer) {
    return drawer && typeof drawer.getSectionsToRender === 'function'
      ? drawer.getSectionsToRender().map(function (section) { return section.id; })
      : [];
  }

  function openThemeCart(drawer, response) {
    if (drawer && typeof drawer.renderContents === 'function') {
      if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(document.activeElement);
      drawer.renderContents(response);
      drawer.classList.remove('is-empty');
      if (typeof drawer.open === 'function') drawer.open();
      return;
    }
    window.location.href = '/cart';
  }

  function addToCart(button) {
    if (!variantId) {
      button.textContent = unavailableLabel;
      return;
    }
    var original = button.textContent;
    button.disabled = true;
    button.textContent = loadingLabel;
    var drawer = document.querySelector('cart-drawer');
    var sections = drawerSections(drawer);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart');
        return response.json();
      })
      .then(function (response) { openThemeCart(drawer, response); })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () {
        button.disabled = false;
        button.textContent = original;
      });
  }

  root.querySelectorAll('[data-stride-add]').forEach(function (button) {
    button.addEventListener('click', function () { addToCart(button); });
  });

  if (sticky && heroButton && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { threshold: 0 }).observe(heroButton);
  }
})();
